<template>
  <div class="us">
    <div class="container">
      <!-- 左侧图片 -->
      <div class="us-img">
        <img src="/imgs/us.jpg" alt="" />
      </div>
      <!-- 右侧 介绍 -->
      <div class="us-info">
        <h2>关于我们</h2>
        <p>
          北京点思传媒有限公司成立于2023年02月28日，注册地位于北京市朝阳区来广营西路5号院5号楼5层506，
        </p>
        <p>
          经营范围包括：一般项目：电影摄制服务；销售代理；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；软件外包服务；广告设计、代理；广告发布；广告制作；会议及展览服务；组织文化艺术交流活动；企业形象策划。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）许可项目：第二类增值电信业务。（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）（不得从事国家和本市产业政策禁止和限制类项目的经营活动。）
        </p>

        <!-- <div class="us-btn" @click="goUs()">
          <span> MORE ></span>
          <div class="blink"></div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    // 关于我们跳转
    goUs() {
      this.$router.push("/ac2");
    },
  },
  mounted() {
    document.title = "点思传媒";
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.us {
  width: 100%;
  height: 400px;
  //   margin: 150px auto;
  margin-top: 120px;

  //   @include flex();
  .container {
    height: 100%;
    @include flex();

    // 左侧图片
    .us-img {
      width: 50%;
      height: 100%;
      text-align: center;

      img {
        width: 400px;
        height: 400px;
        // margin: 30px auto;
      }
    }

    // 右侧 信息
    .us-info {
      width: 50%;
      height: 100%;
      // background-color: pink;
      padding-top: 30px;
      box-sizing: border-box;

      h2 {
        font-size: 31px;
      }

      p {
        font-size: 14px;
        margin: 32px auto;
      }

      .us-btn {
        width: 150px;
        text-align: center;
        height: 40px;
        //   background: #eee;
        position: relative;
        cursor: pointer;

        &:hover span {
          color: #fff;
        }

        &:hover .blink {
          height: 100%;
        }

        span {
          color: turquoise;
          position: absolute;
          left: 33%;
          bottom: 11px;
          z-index: 10;
          transition: all 0.2s;
        }

        .blink {
          width: 100%;
          height: 3px;
          background-color: turquoise;
          position: absolute;
          left: 0;
          bottom: 0;
          transition: all 0.3s;
        }
      }
    }
  }
}
</style>
